var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.608 13.718l-3.476-3.476c-.018-.018-.04-.031-.059-.049a6.58 6.58 0 10-1.88 1.88c.017.019.03.041.049.059l3.476 3.476a1.337 1.337 0 101.891-1.891zm-9.03-2.842a4.3 4.3 0 114.3-4.3 4.3 4.3 0 01-4.3 4.3z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "media/icons/icn_search-f079e1f7.svg";
export { SvgIcnSearch as ReactComponent };